import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import styled, { css } from 'styled-components'

export const ItemForShadowEffectWrapper = styled.div<{
  $fromTop: boolean
  $isVisible: boolean
  $isTop: boolean
}>`
  position: absolute;
  left: 0;
  height: 20px;
  pointer-events: none;
  z-index: 10;
  right: 0;
  opacity: ${props => (props.$isVisible ? '1' : '0')};
  margin: 0 10px;
  transition: opacity 0.2s ease-in-out;

  ${props =>
    props.$fromTop
      ? css`
          top: ${props.$isTop ? '48px' : '0'};
          background: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 100%
          );
        `
      : css`
          bottom: -8px;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 100%
          );
        `};

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    margin: 0;
  }
`
